import * as React from 'react';
import { Fragment } from 'react';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Box from '@mui/material/Box';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridViewIcon from '@mui/icons-material/GridView';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import WalletIcon from '@mui/icons-material/Wallet';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AppsIcon from '@mui/icons-material/Apps';

export default function Online() {
  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: <DashboardIcon />,
      route: '/'
    },
    {
      id: 'deposit',
      label: 'Deposit',
      icon: <ArrowDownwardIcon />,
      route: '/receive'
    },
    {
      id: 'withdraw',
      label: 'Withdraw',
      icon: <AccountBalanceWalletIcon />,
      route: '/send-coin'
    },
    {
      id: 'swap',
      label: 'Swap',
      icon: <SwapHorizIcon />,
      route: '/swap-coin'
    },
    {
      id: 'invest',
      label: 'Invest',
      icon: <ShowChartIcon />,
      route: '/plans'
    },
    {
      id: 'copy-trade',
      label: 'Copy Trade',
      icon: <ContentCopyIcon />,
      route: '/copy-plans'
    },
    {
      id: 'dapps',
      label: 'DApps',
      icon: <AppsIcon />,
      route: '/connect-wallet'
    },
    {
      id: 'assets',
      label: 'Wallet',
      icon: <WalletIcon />,
      route: '/assets'
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: <BarChartIcon />,
      route: '/account-wallet'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: <SettingsIcon />,
      route: '/settings'
    },
    {
      id: 'account',
      label: 'Account',
      icon: <AccountCircleIcon />,
      route: '/profile'
    }
  ];

  return (
    <Fragment>
      <List sx={{ bgcolor: 'background.paper', color: 'text.primary', fontFamily: '"Source Sans 3", "Segoe UI", sans-serif' }}>
        {navItems.map((item) => (
          <Link key={item.id} to={item.route} component={RouterLink} underline="none" color="inherit">
            <ListItem disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Box
                    sx={{
                      color: 'text.secondary',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </Box>
                </ListItemIcon>
                <ListItemText 
                  primary={item.label}
                  primaryTypographyProps={{
                    sx: { color: 'text.primary', fontFamily: '"Source Sans 3", "Segoe UI", sans-serif', fontWeight: 500, letterSpacing: '0.01em' }
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
    </Fragment>
  );
}
